import { useContext } from 'react'
import { SettingsContext } from 'app/contexts/SettingsContext'

export function useSettings() {
    const context = useContext(SettingsContext);
  
    return context;
}
  

